declare namespace $ {

	type $mol_string__value_bog_ainews_app_filters_1 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_filters['include_string_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_ainews_app_filters_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_minor__click_bog_ainews_app_filters_3 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_filters['include_string_clear_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ainews_app_filters_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_labeler__title_bog_ainews_app_filters_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_filters_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_bog_ainews_app_filters_7 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_filters['exclude_string_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_ainews_app_filters_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_minor__click_bog_ainews_app_filters_9 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_filters['exclude_string_clear_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ainews_app_filters_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_labeler__title_bog_ainews_app_filters_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_filters_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_bog_ainews_app_filters_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_bog_ainews_app_filters_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_filters_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $bog_ainews_app_filters extends $bog_ainews_app_page {
		include_string_value( next?: string ): string
		Include_string( ): $mol_string
		include_string_clear_click( next?: any ): any
		Include_string_close_icon( ): $mol_icon_close
		Include_string_clear_button( ): $mol_button_minor
		Include_labeler( ): $mol_labeler
		exclude_string_value( next?: string ): string
		Exclude_string( ): $mol_string
		exclude_string_clear_click( next?: any ): any
		Exclude_string_close_icon( ): $mol_icon_close
		Exclude_string_clear_button( ): $mol_button_minor
		Excldue_labeler( ): $mol_labeler
		Tip( ): $mol_paragraph
		Tip_labeler( ): $mol_labeler
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=filters.view.tree.d.ts.map